import Button from "@/components/common/Button";
import { useTranslation } from "react-i18next";

interface NotificationFooterProps {
  notifications: any[];
  loading: boolean;
  onClearAll: () => void;
}

const NotificationFooter = ({ notifications, loading, onClearAll }: NotificationFooterProps) => {
  const { t } = useTranslation();

  const activeNotifications = notifications.filter((n: any) => n.isActive !== false);

  if (activeNotifications.length === 0) {
    return null;
  }

  return (
    <div className="border-t border-gray-200 px-4 py-3 dark:border-gray-700">
      <div className="flex items-center justify-between">
        <p className="text-xs text-gray-500 dark:text-gray-400">
          {t("admin.notifications.totalNotifications", { count: activeNotifications.length })}
        </p>
        <Button
          variant="outline"
          size="sm"
          onClick={onClearAll}
          loading={loading}
          disabled={loading}
        >
          {t("admin.notifications.clearAll")}
        </Button>
      </div>
    </div>
  );
};

export default NotificationFooter;

